/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react'
import { View, Image, StyleSheet, ImageBackground, Animated } from 'react-native'
import { commonStyle } from '../../assets/TextStyles/TextStyles'
import Button from '../Button/Button'
import dialogHoles from './holes.png'
import headerLine from './repeatable_line.png'

const HEADER_RADIUS = 20

const Dialog = (props) => {
  const fadeAnim = useRef(new Animated.Value(0)).current
  const hasBeenCalled = useRef(false)
  const showHeader = ('showHeader' in props) ? props.showHeader : false

  const fadeIn = () => {
    // Will change fadeAnim value to 1 in 5 seconds
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 500,
      useNativeDriver: false
    }).start()
  }

  useEffect(() => {
    if (props.show === true) {
      fadeIn()
    } else {
      fadeAnim.setValue(0)
    }
  }, [props.show])

  useEffect(() => {
    if (hasBeenCalled.current) return
    hasBeenCalled.current = true
  }, [])

  return (
    <>
      { props.show &&
        <Animated.View style={[styles.feedback, commonStyle.corner, commonStyle.dropShadow, props.style, { opacity: fadeAnim }]}>
          { showHeader &&
            <ImageBackground id={'header'} style={styles.header} imageStyle={{ borderTopLeftRadius: HEADER_RADIUS, borderTopRightRadius: HEADER_RADIUS }} resizeMode={'repeat'} source={headerLine}>
                <Image style={styles.headerImg} source={dialogHoles} />
            </ImageBackground>
          }
          <View id={'content'} style={styles.content}>
                {props.content}
          </View>
          { props.footer.length > 0 &&
            <View id={'footer'} style={styles.footer}>
              <View style={styles.buttonRow}>
              {
                props.footer.map((val, i) => {
                  if (val.title === undefined) {
                    return <Button baseColor={'transparent'} hoverColor={'transparent'} key={'btn' + i} id={'btn' + i} Title={val.title} onPress={val.callback} />
                  } else if (i === 1) {
                    return <Button baseColor={'#cf4b59'} hoverColor={'#f05767'} key={'btn' + i} id={'btn' + i} Title={val.title} onPress={val.callback} />
                  }
                  return <Button key={'btn' + i} id={'btn' + i} Title={val.title} onPress={val.callback} />
                })
              }
              </View>
            </View>
          }
        </Animated.View>
      }
    </>
  )
}

const styles = StyleSheet.create({
  feedback: {
    flex: 1,
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    left: 290,
    alignItems: 'flex-start',
    backgroundColor: 'white',
    width: 580,
    maxHeight: 635,
    margin: 20,
    zIndex: 1
  },
  header: {
    height: 61,
    alignItems: 'center',
    width: '100%',
    borderRadius: HEADER_RADIUS
  },
  content: {
    flex: 1,
    padding: 40,
    paddingTop: 20,
    width: '100%',
    alignItems: 'left'
  },
  footer: {
    height: 81,
    width: '100%',
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 40
  },
  buttonRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  headerImg: {
    marginTop: 20,
    width: 262,
    height: 19
  },
  h1: {
    fontFamily: 'OpenSans_700Bold',
    fontSize: 30,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center'
  },
  h2: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center'
  }
})

export default Dialog
